<template>
  <div>
    <a-modal
      v-model="visible"
      :title="title"
      ok-text="确认"
      cancel-text="取消"
      :centered="true"
      :footer="null"
      :width="684"
      :zIndex="1030"
      class="create-overtime-modal"
    >
      <ValidationObserver ref="formCreate" v-slot="{ handleSubmit }">
        <CForm
          class="create_form"
          @submit.prevent="handleSubmit(createOverTimeRequest)"
        >
          <CRow class="form-input" v-if="projectsEmployees">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_project_name") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.project_name"
              >
                <select
                  class="form-control"
                  v-model="forms.project_id"
                  @change="changeProject()"
                >
                  <option
                    v-for="(option, index) in projectsEmployees"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_approve_person1") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.approve"
              >
                <select
                  class="form-control"
                  v-model="forms.approve_person_1"
                  v-if="
                    forms.project_id &&
                    approvalPersons[forms.project_id]['level1']
                  "
                >
                  <option
                    v-for="(option, index) in approvalPersons[forms.project_id][
                      'level1'
                    ]"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <select
                  class="form-control"
                  v-model="forms.approve_person_1"
                  v-else
                >
                  <option
                    v-for="(option, index) in approvalPersons['level1']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>

          <CRow
            class="form-input"
            v-if="
              forms.approve_person_2 !== forms.approve_person_1 &&
              ((forms.project_id &&
                approvalPersons[forms.project_id]['level2']) ||
                (!forms.project_id &&
                  approvalPersons['level2'] &&
                  approvalPersons['level2'].length > 0))
            "
          >
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_approve_person2") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.approve2"
              >
                <select
                  class="form-control"
                  v-model="forms.approve_person_2"
                  v-if="
                    forms.project_id &&
                    approvalPersons[forms.project_id]['level2']
                  "
                >
                  <option
                    v-for="(option, index) in approvalPersons[forms.project_id][
                      'level2'
                    ]"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <select
                  class="form-control"
                  disabled
                  v-model="forms.approve_person_2"
                  v-else
                >
                  <option
                    v-for="(option, index) in approvalPersons['level2']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>

          <CRow
            class="form-input"
            v-if="
              (forms.project_id &&
                approvalPersons[forms.project_id]['level3']) ||
              (!forms.project_id &&
                approvalPersons['level3'] &&
                approvalPersons['level3'].length > 0)
            "
          >
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_approve_person3") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.approve3"
              >
                <select
                  class="form-control"
                  v-model="forms.approve_person_3"
                  v-if="
                    forms.project_id &&
                    approvalPersons[forms.project_id]['level3']
                  "
                >
                  <option
                    v-for="(option, index) in approvalPersons[forms.project_id][
                      'level3'
                    ]"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <select
                  class="form-control"
                  disabled
                  v-model="forms.approve_person_3"
                  v-else
                >
                  <option
                    v-for="(option, index) in approvalPersons['level3']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>

          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("overtime.date") }}
                <span class="require">*</span>
              </label>
              <div>
                <a-date-picker
                  :disabled-date="disabledDate"
                  :disabled="isDisableTimepicker"
                  format="DD/MM/YYYY"
                  v-model="forms.current_date"
                  :placeholder="$t('overtime.date')"
                  @change="onChange"
                />
              </div>

              <!-- <DatePickerOT
                :propsDate="forms.date ? forms.date : forms.current_date"
                v-on:emitDate="workDate"
                :rules="{ required_date: true }"
                :name="'overtime.date'"
              /> -->
            </CCol>
          </CRow>

          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("overtime.start_time") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.start_time"
              >
                <b-form-input
                  type="text"
                  v-model="forms.start_time"
                  v-mask="'##:##'"
                  placeholder="HH:mm"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>

          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("overtime.end_time") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.end_time"
              >
                <b-form-input
                  type="text"
                  v-model="forms.end_time"
                  v-mask="'##:##'"
                  placeholder="HH:mm"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>

          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_reason") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required|max:512"
                v-slot="{ errors }"
                name="overtime.reason"
              >
                <b-form-textarea
                  class="textarea-input"
                  id="textarea"
                  rows="6"
                  max-rows="8"
                  v-model="forms.reason"
                >
                </b-form-textarea>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>

          <CRow class="form-button">
            <CCol md="12" class="employees-form-ot">
              <CButton type="submit" class="save-info"
                >{{ $t("label.save_infomation") }}
              </CButton>
              <CButton
                class="cancel-employee"
                type="button"
                @click="hideModal()"
                >{{ $t("commons.cancel") }}
              </CButton>
            </CCol>
          </CRow>
        </CForm>
      </ValidationObserver>
    </a-modal>
    <CusPopupNoti
      @handleCancel="hidePopupNotInProject"
      @handleOk="hidePopupNotInProject"
      :title="$t('error.error') + '!'"
      :isShow="isShowPopupNotInProject"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.overtime.message_popup_not_in_project") }}
        </div>
      </div>
    </CusPopupNoti>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import CusPopupNoti from "@/components/commons/CusPopupNoti.vue";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    CusPopupNoti,
  },
  computed: {
    ...mapGetters({
      projectsEmployees: "overtime-request/projectsEmployees",
      approvalPersons: "overtime-request/approvalPersons",
    }),
  },
  data() {
    return {
      title: this.$t("popup.overtime.label_popup_create"),
      visible: false,
      forms: {
        project_id: "",
        approve_person_1: "",
        approve_person_2: "",
        approve_person_3: "",
        date: null,
        start_time: null,
        end_time: null,
        reason:
          "Link issue: https://backlog.fabbi.io/issue/aBcxYz \nLý do OT: Lý do OT",
        current_date: moment(new Date()).subtract(1, "days"),
      },
      text: "Link issue: {https://backlog.fabbi.io/issue/aBcxYz}\nLý do OT: {Lý do OT}",
      employees: [],
      approvalPerson: [],
      isShowPopupNotInProject: false,
      isDisableTimepicker: false
    };
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),
    onChange(date) {
      this.forms.date = moment(date).format("DD/MM/YYYY");
    },

    disabledDate(current) {
      return (
        current < moment().subtract(8, "days") ||
        moment(current).isSameOrAfter(moment(), "day")
      );
    },

    async showModal(date) {
      this.forms.project_id = "";
      this.forms.approve_person_1 = "";
      this.forms.approve_person_2 = "";
      this.forms.approve_person_3 = "";
      this.forms.date = null;
      this.forms.start_time = "";
      this.forms.end_time = "";
      this.forms.reason =
        "Link issue: https://backlog.fabbi.io/issue/aBcxYz \nLý do OT: Lý do OT";
        if(date){
          this.isDisableTimepicker = true;
        }
      this.forms.current_date = date ?  moment(date, "DD/MM/YYYY") : moment(new Date()).subtract(1, "days");

      const validate = this.$refs.formCreate;
      if (typeof validate !== "undefined") {
        this.$refs.formCreate.reset();
      }

      this.$root.$loading.start();

      await this.$store.dispatch("overtime-request/getProjectEmployee");
      if (!this.projectsEmployees) {
        this.$root.$loading.finish();
        // this.$confirmModal(
        //   this.$t("popup.overtime.message_popup_not_in_project"),
        //   this.$t("popup.overtime.label_popup_create"),
        //   this.$t("popup.overtime.label_popup_title_confirm"),
        //   this.$t("popup.overtime.label_cancel_button"),
        //   "danger"
        // ).then(() => {
        //   // this.$router.push({
        //   //   path: "/overtime-requests",
        //   // });
        //   this.hideModal();
        // });
        // return;
        this.isShowPopupNotInProject = true;
      } else {
        this.visible = true;
      }
      await this.$store.dispatch("overtime-request/getApprovalPerson");
      if (this.projectsEmployees) {
        this.forms.project_id = this.projectsEmployees[0]["id"] ?? null;
        this.forms.approve_person_1 =
          this.approvalPersons[this.forms.project_id] &&
          this.approvalPersons[this.forms.project_id]["level1"][0]["id"]
            ? this.approvalPersons[this.forms.project_id]["level1"][0]["id"]
            : "";
        this.forms.approve_person_2 =
          this.approvalPersons[this.forms.project_id] &&
          this.approvalPersons[this.forms.project_id]["level2"]
            ? this.approvalPersons[this.forms.project_id]["level2"][0]["id"]
            : "";
        this.forms.approve_person_3 =
          this.approvalPersons[this.forms.project_id] &&
          this.approvalPersons[this.forms.project_id]["level3"]
            ? this.approvalPersons[this.forms.project_id]["level3"][0]["id"]
            : "";
      } else if (this.approvalPersons){
        
        this.forms.approve_person_1 =
          this.approvalPersons["level1"] && this.approvalPersons["level1"][0]
            ? this.approvalPersons["level1"][0]["id"]
            : "";
        this.forms.approve_person_2 =
          this.approvalPersons["level2"] && this.approvalPersons["level2"][0]
            ? this.approvalPersons["level2"][0]["id"]
            : "";
        this.forms.approve_person_3 =
          this.approvalPersons["level3"] && this.approvalPersons["level3"][0]
            ? this.approvalPersons["level3"][0]["id"]
            : "";
      }
      this.$root.$loading.finish();
    },
    hideModal() {
      this.visible = false;
    },
    hidePopupNotInProject() {
      if(!this.isDisableTimepicker && this.$route.path != "/overtime-requests") {
         this.$router.push({
        path: "/overtime-requests",
      });
      }
      this.hideModal();
      this.isShowPopupNotInProject = false;
    },
    workDate(data) {
      this.forms.date = data;
    },
    async createOverTimeRequest() {
      this.$root.$loading.start();
      if (!this.forms.date) {
        this.forms.date = moment(this.forms.current_date).format("DD/MM/YYYY");
      }
      await this.$store
        .dispatch("overtime-request/createOverTime", this.forms)
        .then(() => {
          let message = this.$t("overtime.message_create_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$emit("fetchData");
          this.$emit("fetchTotalRequest");
          this.$store.dispatch("commons/getCountRequest");
          this.visible = false;
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    cancel() {
      // this.$confirm(
      //   this.$t("popup.employee.label_popup_title"),
      //   this.$t("popup.overtime.label_popup_title"),
      //   this.$t("popup.employee.label_confirm_button"),
      //   this.$t("popup.employee.label_cancel_button"),
      //   "danger"
      // ).then((value) => {
      //   if (value) {
      //     this.$router.push({ path: "/overtime-requests" });
      //   }
      // });

      this.$confirmModal({
        centered: true,
        zIndex: 1031,
        content: "Hủy tạo đơn OT?",
        onOk: () => {
          setTimeout(this.hideModal(), 1000);
        },
      });
    },

    changeProject() {
      this.forms.approve_person_1 =
        this.approvalPersons[this.forms.project_id]["level1"][0]["id"];
      this.forms.approve_person_2 = this.approvalPersons[this.forms.project_id][
        "level2"
      ]
        ? this.approvalPersons[this.forms.project_id]["level2"][0]["id"]
        : "";
      this.forms.approve_person_3 = this.approvalPersons[this.forms.project_id][
        "level3"
      ]
        ? this.approvalPersons[this.forms.project_id]["level3"][0]["id"]
        : "";
    },
  },
};
</script>

<style lang="scss">
.create-overtime-modal {
  .ant-modal-content{
    border-radius: 10px;
  }
  .ant-modal-header {
    background-color: #d2d6ff;
    border-bottom-color: #3d4cdc;
    border-radius: 10px 10px 0 0 ;
    .ant-modal-title {
      color: #3d4cdc;
      font-weight: 700;
    }
  }
  .ant-modal-body{
    border-radius: 0px 0px 10px 10px ;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .modal-content {
  border: unset;
  .warning-title {
    text-align: center;
  }
}
/deep/ .ant-modal-wrap {
  &::-webkit-scrollbar {
    display: none;
  }
}
.create_form {
  max-width: 440px;
  margin: 0 auto;

  .form-input {
    margin-bottom: 16px;
    .form-field {
      .form-label {
        font-weight: 700;
        font-size: 14px;
        color: #303c54;

        .require {
          color: #f03d3e;
        }
      }

      /deep/ .ant-calendar-picker {
        width: 100%;

        .ant-input {
          height: 35px;
        }
      }

      .textarea-input {
        border: 1px solid #cfcfcf;
        border-radius: 10px;
      }

      .required {
        color: #f03d3e;
      }
    }
  }

  .form-button {
    .employees-form-ot {
      display: flex;
      gap: 20px;
      .save-info {
        width: 50%;
        background: #3d4cdc;
        border-radius: 10px;
        font-weight: 700;
        font-size: 14px;
        color: #ffffff;
      }
      .cancel-employee {
        width: 50%;
        background: #ececec;
        border-radius: 10px;
        color: #6f6f6f;
        font-weight: 700;
        font-size: 14px;
      }
    }
  }
}
</style>
